/* tslint:disable */
/* eslint-disable */
/**
 * REGUZA
 * Aspe licensing management tool
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UpdatePriceListProductPrice } from './UpdatePriceListProductPrice';
import {
    UpdatePriceListProductPriceFromJSON,
    UpdatePriceListProductPriceFromJSONTyped,
    UpdatePriceListProductPriceToJSON,
    UpdatePriceListProductPriceToJSONTyped,
} from './UpdatePriceListProductPrice';

/**
 * 
 * @export
 * @interface UpdatePriceListProductPriceRequest
 */
export interface UpdatePriceListProductPriceRequest {
    /**
     * 
     * @type {Array<UpdatePriceListProductPrice>}
     * @memberof UpdatePriceListProductPriceRequest
     */
    products: Array<UpdatePriceListProductPrice>;
}

/**
 * Check if a given object implements the UpdatePriceListProductPriceRequest interface.
 */
export function instanceOfUpdatePriceListProductPriceRequest(value: object): value is UpdatePriceListProductPriceRequest {
    if (!('products' in value) || value['products'] === undefined) return false;
    return true;
}

export function UpdatePriceListProductPriceRequestFromJSON(json: any): UpdatePriceListProductPriceRequest {
    return UpdatePriceListProductPriceRequestFromJSONTyped(json, false);
}

export function UpdatePriceListProductPriceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePriceListProductPriceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'products': ((json['products'] as Array<any>).map(UpdatePriceListProductPriceFromJSON)),
    };
}

export function UpdatePriceListProductPriceRequestToJSON(json: any): UpdatePriceListProductPriceRequest {
    return UpdatePriceListProductPriceRequestToJSONTyped(json, false);
}

export function UpdatePriceListProductPriceRequestToJSONTyped(value?: UpdatePriceListProductPriceRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'products': ((value['products'] as Array<any>).map(UpdatePriceListProductPriceToJSON)),
    };
}

